/* eslint-disable */
import React from 'react';
import compose from 'lodash/fp/compose';
import {
  withDocumentType,
  withDataArea,
  withTranslation,
  withLanguage,
  withAttachmentRule,
  withCustomRouter,
  withUserLayoutChoice,
  withBulkDelete,
  withUserPreferences,
} from 'components/hoc';
import MyDataContentTemplate from 'components/Dashboard/MyData/common/MyDataContentTemplate';
import LottieLoader from 'components/common/LottieLoader';
import EmptyState from 'components/common/EmptyState';
import { getFullName } from 'components/utils/getFullName'



const AttachmentRule = (props) => {
  const mapFields = () => {
    const { attachmentRules, trObj, fd } = props;
    return attachmentRules.data.map((data) => {
      const orgName = data.organisation_detail?.name;
      const truncatedName = orgName && orgName.length > 25
        ? `${orgName.substring(0, 25)}...`
        : orgName;
      return {
        ...data,
        space_name: data.space,
        person: getFullName(data?.person_detail),
        organisation: truncatedName,
        document_type: trObj(data.document_type_detail),
        data_area: trObj(data.data_area_detail),
        language: trObj(data.language_detail),
        country: data.country_id ? trObj(data.country_detail) : '',
        state: data.state_id ? trObj(data.state_detail) : '',
        city: data.city_id ? trObj(data.city_detail) : '',
      };
    });
  };

  const {
    gotoCreatePath,
    loaded,
    attachmentRules,
    deleteBulkAttachmentRule,
    tr,
  } = props;

  const tableName = 'attachment_rule';

  // `loaded` now comes from the store and is set on success *and* failure, so
  // a failed request shows the error below instead of spinning forever.
  if (!loaded) {
    return <LottieLoader />;
  }

  if (attachmentRules.errors) {
    return (
      <div className="p-4">
        <EmptyState
          text={tr(
            'Could not load attachment rules. Please refresh the page to try again.',
          )}
          hasButton={false}
        />
      </div>
    );
  }

  return (
    
    <MyDataContentTemplate
      tableName={tableName}
      columns={[]}
      data={mapFields()}
      handleCreateForm={gotoCreatePath}
      bulkDelete={deleteBulkAttachmentRule}
    />
  );
};

export default compose(
  withCustomRouter,
  withDocumentType,
  withDataArea,
  withTranslation,
  withLanguage,
  withAttachmentRule,
  withUserLayoutChoice,
  withBulkDelete,
  withUserPreferences,
)(AttachmentRule);
